// Asset position for story component.
export const CtfAssetPositions = {
  LEFT: 'Left',
  RIGHT: 'Right',
};

export const CtfAssetOrientations = {
  LANDSCAPE: 'Landscape',
  LANDSCAPE_SMALL: 'Landscape Small',
  PORTRAIT: 'Portrait',
}

export const CtfTwoColumnGap = {
  NARROW: 'Narrow',
  WIDE: 'Wide',
}

// Asset type
export const CtfAssetType = {
  IMAGE: 'image',
  VIDEO: 'video',
};

// List of two column content type from contentful
export const CtfTwoColumnContentStyle = {
  LEGAL: 'legal',
  RECIPE_DD: 'recipe-dd',
};

// List of lead generation type from contentful. For analytics purpose
export const CtfLeadGenType = {
  OFFER: 'offer',
  SIGNUP: 'signup',
};

export const CtfWHLeadGenType = {
  GENERAL: 'General form',
  PRODUCT: 'Product form',
  PURCHASE: 'Purchase form',
  SIGNUP: 'Sign-up form',
}

// List of carousel styles from contentful.
export const CtfCarouselStyle = {
  FEATURED: 'Featured',
  FEATURED_ASYMMETRIC: 'Featured (Asymmetric Content Width)',
  FEATURED_ASYMMETRIC_FULL: 'Featured (Asymmetric Full Width)',
  FEATURED_FULL: 'Featured (Full Width)',
  HERO: 'Hero',
  NORMAL: 'Normal',
  SLIDER: 'Slider',
};

// List of carousel styles from contentful.
export const CtfStoryStyle = {
  ASSET: 'Featured Asset',
  NORMAL: 'Normal',
  RECIPE_STEPS: 'Recipe Steps',
  TWO_COLUMNS: 'Two Columns',
};

// List of content types from contentful.
export const CtfContentTypes = {
  CARD: 'card',
  INGREDIENT_SECTION: 'ingredientSection',
  NAVIGATION: 'navigation,',
  PAGE: 'page',
  ROBOT: 'robot',
  TAG: 'tag',
  TAG_GROUP: 'tagGroup',
};

// CTA style enum from contentful
export const CtfCtaStyle = {
  // only on DD
  DD_DEFAULT: 'DDDefault',
  DD_PRIMARY_FILLED: 'DDPrimaryFilled',
  DD_PRIMARY_LINE: 'DDPrimaryLine',
  DD_SECONDARY: 'DDSecondary',
  DD_TERTIARY: 'DDTertiary',
  // WH and DD
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary',
};

// Static slug for pages from contentful.
export const CtfPageSlug = {
  HOME: 'home',
};

// List of tags from contentful.
export const CtfTags = {
  STANDALONE: 'standalone',
};

// Pagination defaults
export const PaginationDefaults = {
  LIMIT: 9,
};

// BlockText style from contentful
export const CtfBlockTextStyle = {
  BLOCKQUOTE: 'blockquote',
  BLOCKQUOTE_BODY_LARGE: 'blockquote-body-large',
  TEXT: 'text',
};

// RichText nodeType
export const CtfRichTextTag = {
  BLOCKQUOTE: 'blockquote',
  ENTRY_HYPERLINK: 'entry-hyperlink',
  HEADING_1: 'heading-1',
  HEADING_2: 'heading-2',
  HEADING_3: 'heading-3',
  HEADING_4: 'heading-4',
  HEADING_5: 'heading-5',
  HEADING_6: 'heading-6',
  HR: 'hr',
  HYPERLINK: 'hyperlink',
  OL: 'ordered-list',
  PARAGRAPH: 'paragraph',
  TABLE: 'table',
  TABLE_HEADER_CELL: 'table-header-cel',
  UL: 'unordered-list',
};

// BlockText position from contentful
export const CtfBlockTextPositions = {
  LEFT: 'Left',
  RIGHT: 'Right',
};

// SectionHeader type from contentful
export const CtfSectionHeaderType = {
  LEVEL_2: 'level-2',
  LEVEL_3: 'level-3',
  PAGE: 'page',
  PAGE_LARGE: 'page-large', // for DD's 404
  SECTION: 'section',
  H_4: 'h-4',
};

export const CtfSectionHeaderHeadingSize = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
};

// SectionHeader position from contentful
export const CtfSectionHeaderPositions = {
  CENTER: 'Center',
  LEFT: 'Left',
  RIGHT: 'Right',
};

export const CtfWidthOptions = {
  FULL_WIDTH: 'Full Width',
  NO_LEFT: 'No Left Padding',
  NO_RIGHT: 'No Right Padding',
  PADDING: 'Full Padding',
};

export const CtfChefIntroStyle = {
  CUSTOM: 'custom',
  RECIPE: 'recipe',
  RESTAURANT: 'restaurant',
};

// List of navigation styles from contentful.
export const CtfNavigationStyle = {
  DEFAULT: 'Default',
  STICKY: 'Sticky',
};

// Content Query Order for dynamic
export const CtfContentQueryOrder = {
  CREATE_DATE: 'Create Date',
  PUBLISH_DATE: 'Publish Date',
};

export const ContentQueryOrder = {
  CREATE_DATE: '-sys.createdAt',
  PUBLISH_DATE: '-fields.publishDate',
};

// List of background color from contentful.
export const CtfBackgroundColor = {
  DARK_WARM_GREY: 'dark-warm-grey',
  EUCALYPTUS: 'eucalyptus',
  TRANSPARENT: '(none)',
  WARM_GREY: 'warm-grey',
  WARMER_GREY: 'warmer-grey',
  WHITE: 'white',
}

export const CtfStoryProductCaptionStyle = {
  CENTER: 'Center',
  BOTTOM_LEFT: 'Bottom Left',
}

export const CtfAdditionalTitleAndTextSize = {
  Normal: 'Normal',
  SMALL: 'Small',
}

export const CtfAdditionalTitleAndTextPosition = {
  Normal: 'Normal',
  BOTTOM: 'Bottom',
}
